import React, { Component } from 'react';
import './index.css';

import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc'

import State from '../State'


const SortableItem = SortableElement(({field}) => {
  // console.log('field', field)
  let className = 'field-list-item no-select ' + (field.active ? 'active' : '')
  return (
    <div className={className} onClick={() => State.action('toggleField', field.name)} >
      <span><i className="fa fa-bars"></i> {field.label + (field.active ? ' \u2713' : '')}</span>
    </div>
  )
  }
);

const SortableList = SortableContainer(({items}) => {
  // console.log('items', items)
  return (
    <div>
      {items.map((field, i) => (
        <SortableItem key={`item-${i}`} index={i} field={field} useDragHandle={true} />
      ))}
    </div>
  );
});


class Fieldlist extends Component {

  onSortEnd = ({oldIndex, newIndex}) => {
    let cur = State.nestFields.map(d => d)
    cur = arrayMove(cur, oldIndex, newIndex)
    State.action('updateNestFields', cur)
  }

  render() {
    // console.log(State.nestFields)
    return <SortableList className="field-list" items={State.nestFields} onSortEnd={this.onSortEnd} distance={10} />;
  }
}

export default Fieldlist;



// WEBPACK FOOTER //
// ./src/Fieldlist/index.js